import { useFormik } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { useSearchAgents } from "../../../hooks/useSearchAgents";
import { useAgentNavigation } from "./useAgentNavigation";
import { agentPhoneSearchSchema } from "../validation/agentPhoneSearchSchema";
import { useAgentSearchUIState } from "./useAgentSearchUIState";
import { CONSTANTS } from "../../../constants/constants";

export const useAgentSearch = () => {
  const { mutateAsync } = useSearchAgents();
  const { navigateToAgentDetails } = useAgentNavigation();
  const {
    errorSnackbar,
    openErrorSnackbar,
    closeErrorSnackbar,
  } = useAgentSearchUIState();


  const formik = useFormik({
    initialValues: {
      phone: "",
    },
    validationSchema: toFormikValidationSchema(agentPhoneSearchSchema),
    validateOnMount: false,
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const response = await mutateAsync({ phone: values.phone });
        const agents =
          response && Array.isArray(response.agents) ? response.agents : [];

        if (agents.length >= CONSTANTS.ONE) {
          navigateToAgentDetails(agents[CONSTANTS.ZERO], values);
        } else {
          openErrorSnackbar(
            "No agent found with the provided phone number.",
          );
        }
      } catch {
        openErrorSnackbar("No agent found. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return {
    formik,
    errorSnackbar,
    closeErrorSnackbar,
  };
};
